import React, { useRef, useState, useContext } from 'react'
import {themeContext} from '../../Context'

import emailjs from 'emailjs-com';

import './Form.css'
const Form = () => {
    const theme = useContext(themeContext)
    const darkMode = theme.state.darkMode;
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [message, setMessage] = useState('')
    const [doneContent, setDoneContent] = useState(false)


    const formRef = useRef()
    const submitHandler = (e) => {
        e.preventDefault()
        emailjs.sendForm('service_2mcsris', 'template_4zx0sig', formRef.current, 'KxxAmggeSTY_cydLU')
            .then((result) => {
                console.log(result.text);
                setDoneContent(true)
                setName('')
                setEmail('')
                setMessage('')
            }, (error) => {
                console.log(error.text);
                setDoneContent(false)
                setName('')
                setEmail('')
                setMessage('')
            });
    }
    return <form className='form' style={{background: darkMode?'#132347':'rgb(216 212 232)'}} ref={formRef} onSubmit={submitHandler}>
        <div className={`${darkMode?'form_input_dark':'form_input_light'}`}>
            <input type="text" name='user_name' value={name} onChange={(e)=>{setName(e.target.value)}} placeholder='Your Name' />
        </div >
        <div className={`${darkMode?'form_input_dark':'form_input_light'}`}>
            <input type="email" name='user_email' value={email} onChange={(e)=>{setEmail(e.target.value)}} placeholder='Your Email' />
        </div >
        <div className={`${darkMode?'form_input_dark':'form_input_light'}`}>
            <textarea rows='5' name='user_message' value={message} onChange={(e)=>{setMessage(e.target.value)}} placeholder='Message..' />
        </div >
        <div className='w-100'>

        <button className={`submit_btn ${darkMode?'submit_btn_dark':'submit_btn_light'} w-25`} style={{margin:'auto'}} type='submit' >
            Submit
        </button>
        </div>
        <span>{doneContent && <p style={{textAlign:'center',paddingTop: '20px'}}><br/>Thanks for reaching out to me, will contact you shortly</p>}</span>
    </form>
}

export default Form